import { SkeletonItem } from "~/lib/components/ui/SkeletonItem";
import { useHelpCentreConfig } from "~/services/queries/variable.queries";
import { useTranslation } from "~/lib/utils/store/useTranslation";
import { IArticleProps, ISectionProps } from "~/lib/types/article.type";
import { SideBarLink } from "./SideBarLink";
import { useIsMobileUser } from "~/lib/utils/store/useIsMobileUser";

const SideBar = ({
  className,
  article,
}: {
  className?: string;
  article?: IArticleProps;
}) => {
  const { data: helpCentreConfig, isLoading } = useHelpCentreConfig();
  const { isMobileUser } = useIsMobileUser();
  const { t } = useTranslation();
  return (
    <div
      className={`w-full ${className} ${
        isMobileUser ? "hidden" : "flex"
      } flex-col gap-5`}
    >
      <h3 className="md:font-semibold md:leading-7 font-title text-[20px]">
        {t("helpTopics")}
      </h3>

      {isLoading ? (
        <SkeletonItem count={5} />
      ) : (
        helpCentreConfig?.TOPICS?.map((sectionProps: ISectionProps) => (
          <SideBarLink
            key={sectionProps.sectionId}
            sectionProps={sectionProps}
            article={article}
          />
        ))
      )}
    </div>
  );
};

export default SideBar;
